export const HOME_FEATURE_ICONS = {
  apps: require("@/assets/images/home_icons/Apps.svg"),
  assets: require("@/assets/images/home_icons/EngageNet Feature Icons_Assets.svg"),
  boards: require("@/assets/images/home_icons/Boards.svg"),
  business_profile: require("@/assets/images/home_icons/EngageNet Feature Icons_Business Profile.svg"),
  cart: require("@/assets/images/home_icons/Cart.svg"),
  categories: require("@/assets/images/home_icons/EngageNet Feature Icons_Categories.svg"),
  dashboard: require("@/assets/images/home_icons/EngageNet Feature Icons_Dashboard.svg"),
  discussions: require("@/assets/images/home_icons/EngageNet Feature Icons_Discussions.svg"),
  donations: require("@/assets/images/home_icons/EngageNet Feature Icons_Donations.svg"),
  dynamic_forms: require("@/assets/images/home_icons/EngageNet Feature Icons_Dynamic Forms.svg"),
  events: require("@/assets/images/home_icons/EngageNet Feature Icons_Events.svg"),
  post: require("@/assets/images/home_icons/EngageNet Feature Icons_post.svg"),
  feed: require("@/assets/images/home_icons/EngageNet Feature Icons_Feed.svg"),
  notifications: require("@/assets/images/home_icons/EngageNet Feature Icons_Notifications.svg"),
  home: require("@/assets/images/home_icons/EngageNet Feature Icons_Home.svg"),
  groups: require("@/assets/images/home_icons/EngageNet Feature Icons_Groups.svg"),
  incident_reporting: require("@/assets/images/home_icons/EngageNet Feature Icons_Incident Reporting.svg"),
  library: require("@/assets/images/home_icons/EngageNet Feature Icons_Library.svg"),
  marketplace: require("@/assets/images/home_icons/Marketplace.svg"),
  memberships: require("@/assets/images/home_icons/EngageNet Feature Icons_Memeberships.svg"),
  organisation: require("@/assets/images/home_icons/EngageNet Feature Icons_Organisation.svg"),
  personal_profile: require("@/assets/images/home_icons/EngageNet Feature Icons_Personal Profile.svg"),
  polls: require("@/assets/images/home_icons/Polls.svg"),
  portals: require("@/assets/images/home_icons/EngageNet Feature Icons_Portals.svg"),
  products: require("@/assets/images/home_icons/Products.svg"),
  recent_uploads: require("@/assets/images/home_icons/EngageNet Feature Icons_Recent Uploads.svg"),
  search: require("@/assets/images/home_icons/Search Icon.svg"),
  services: require("@/assets/images/home_icons/Services.svg"),
  surveys: require("@/assets/images/home_icons/surveys.svg"),
  tags: require("@/assets/images/home_icons/EngageNet Feature Icons_Tags.svg"),
  upcoming_birthdays: require("@/assets/images/home_icons/EngageNet Feature Icons_Upcoming Birthdays.svg"),
  your_voice: require("@/assets/images/home_icons/EngageNet Feature Icons_Your Voice.svg"),
  section_18a: require("@/assets/images/home_icons/Section 18A.svg"),
};
